import { useState } from "react";
import { projectURL } from "./utils/mockdata";
import { Eye, EyeOff } from "lucide-react";
import Modal from "./Modal";

const Login = () => {
  const [userEmail, setUserEmail] = useState();
  const [password, setPassword] = useState();

  const [isVisible, setIsVisible] = useState(false);

  const [loading, setLoading] = useState(false);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [modalType, setModalType] = useState("info");

  const toggleVisibility = () => setIsVisible(prevState => !prevState);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!userEmail || !password) {
      setModalTitle("Missing Fields");
      setModalMessage("Kindly enter all fields to login your profile.");
      setModalType("info");
      setIsModalOpen(true);
      return;
    }

    const dataInput = {
      email: userEmail,
      password: password
    };

    const loginpath = projectURL + "profiles/login";

    setLoading(true); // Start loader
    try {
      const response = await fetch(loginpath, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataInput),
      });

      if (response.ok) {
        const data = await response.json();
        const username = data?.username;
        const userId = data?._id;
        const userImage = data?.imagePath;

        sessionStorage.setItem("authenticated", true);
        sessionStorage.setItem("loggedUserName", username);
        sessionStorage.setItem("loggedUserId", userId);
        sessionStorage.setItem('loggedInUserImage', userImage);

        setModalTitle("Welcome");
        setModalMessage(`Welcome 😃 ${username}, you have logged in !`);
        setModalType("info");
        setIsModalOpen(true);

        setTimeout(() => {
          setIsModalOpen(false);
          window.location.href = '/dashboard';
        }, 2000);
      } else {
        setModalTitle("Failed");
        setModalMessage("Login Failed. Check Credentials or your IP blocked. Kindly Contact Administator.");
        setModalType("info");
        setIsModalOpen(true);

        setTimeout(() => {
          setIsModalOpen(false);
        }, 2000);

        return;
      }
    } catch (error) {
      // console.error('Authentication Error:', error);
      if (error.name === 'TypeError' && error.message.includes("fetch")) {
        setModalTitle("Type Error");
        setModalMessage("Server unreachable. Please try again in a few seconds.");
        setModalType("error");
        setIsModalOpen(true);
        return;
      } else {
        setModalTitle("Type Error");
        setModalMessage("Login failed due to: " + error.message);
        setModalType("error");
        setIsModalOpen(true);
        return;
      }
    }
    finally {
      setLoading(false); // Stop loader after fetch completes or fails
    }
  };

  return (
    <div>
      <div className="max-w-md mx-auto mt-20 p-6 bg-white rounded-2xl shadow-xl border-2 border-gray-200">
        <div className="sm:mx-auto sm:w-full sm:max-w-sm">
          {/* <img className="max-w-30" src="socio1-3d.png" alt="Your Company" /> */}
          <div className="flex justify-center space-x-2">
            <div className="w-8 h-8 flex items-center justify-center">
              <img className="ring-2 ring-blue max-w-10 w-8 border rounded-full p-1.5" src="icon.jpg" alt="Socio" />
            </div>
            <span className="text-2xl font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent">
              Socio
            </span>
          </div>

          <h2 className="mt-6 text-center text-2xl/5 font-bold tracking-tight text-gray-900">Sign in to your account</h2>
        </div>

        <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <div className="mt-2">
                <input onChange={(e) => { setUserEmail(e.target.value) }} placeholder="Enter Username or Email"
                  id="email" name="email" type="text" required className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-center focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2" />
              </div>
            </div>

            <div>
              <div className="mt-2">
                <div className="relative">
                  <input onChange={(e) => { setPassword(e.target.value) }}
                    id="password"
                    type={isVisible ? "text" : "password"}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-center focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm/6 p-2  "
                    placeholder="Enter Personal Password"
                    aria-label="Password"
                    required
                  />
                  <button
                    className="absolute inset-y-0 end-0 flex items-center z-20 px-2.5 cursor-pointer text-gray-400 rounded-e-md focus:outline-none focus-visible:text-indigo-500 hover:text-indigo-500 transition-colors"
                    type="button"
                    onClick={toggleVisibility}
                    aria-label={isVisible ? "Hide password" : "Show password"}
                    aria-pressed={isVisible}
                    aria-controls="password"
                  >
                    {isVisible ? (
                      <EyeOff size={20} aria-hidden="true" />
                    ) : (
                      <Eye size={20} aria-hidden="true" />
                    )}
                  </button>
                </div>
              </div>
            </div>

            <a href="register" className="underline text-blue-600 hover:text-blue-800 visited:text-purple-600">Register Here</a>


            <div>
              <button
                type="submit"
                className="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm/6 font-semibold text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-full text-sm px-5 py-2.5 text-center"
                disabled={loading}
              >

                {loading && (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                    />
                  </svg>
                )}

                {loading ? "Signing in..." : "Sign in"}
              </button>
            </div>

          </form>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={modalTitle}
        message={modalMessage}
        type={modalType}
      />
    </div>
  );
};


export default Login;